import { DASHBOARD_REPORT_SERVICE_HOSTS } from './config';
import {
  getGetRequestInit,
  getPostRequestInit,
  getProxyServicePath,
  retrieveData,
} from './common';

const serviceEndpoint = getProxyServicePath(DASHBOARD_REPORT_SERVICE_HOSTS);

export const getDashboardReport = async (id, token) => {
  const url = `${serviceEndpoint}/${id}`;

  const requestInit = getGetRequestInit(token);

  return await retrieveData(url, requestInit);
};

export const createDashboardReport = async (dashboardReport, token) => {
  const url = `${serviceEndpoint}`;

  const requestInit = getPostRequestInit(dashboardReport, token);

  return await retrieveData(url, requestInit);
};
